import { useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { CreacionTrasladoApi } from "../api/CreacionTrasladoApi";
import { useDebouncedAsyncSelect } from "../../../../../Utils/Hooks/useDebounce";
import moment from "moment";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

export const useCreacionTraslado = (regresar) => {
    const { crearTraslado, getAcopios, getPilotos, getVehiculos, cargando } =
        CreacionTrasladoApi();

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            fecha_creacion: moment().format("YYYY-MM-DD HH:mm"),
            peso_tara: null,
        },
    });

    // Async loaders
    const loadAcopios = useDebouncedAsyncSelect(function (search) {
        return getAcopios({ search: search, exclude_current: true });
    });

    const loadPilotos = useDebouncedAsyncSelect(function (search) {
        return getPilotos({ search: search });
    });

    const loadVehiculos = useDebouncedAsyncSelect(function (search) {
        return getVehiculos({ search: search });
    });

    // Submit
    const CrearTraslado = async function () {
        const isValid = await validateForm();
        if (!isValid) return;

        const values = formGetValues();

        try {
            await crearTraslado({
                acopio_destino_id:
                    values.acopio && values.acopio.id ? values.acopio.id : null,
                piloto_id:
                    values.piloto && values.piloto.id ? values.piloto.id : null,
                vehiculo_id:
                    values.vehiculo && values.vehiculo.id
                        ? values.vehiculo.id
                        : null,
                peso_tara: values.peso_tara,
            });

            Swal.fire({
                title: "¡Éxito!",
                text: "El traslado se ha creado correctamente",
                type: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(error, "No se pudo crear el traslado.");
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
        }
    };

    return {
        formControl,
        formRegister,
        formSetValue,
        formGetValues,
        errors,

        loadAcopios,
        loadPilotos,
        loadVehiculos,
        CrearTraslado,
        cargando,
    };
};
